import React from 'react'
import { Sort, Straight } from '@mui/icons-material'
import { SelectChangeEvent } from '@mui/material'
import { useIntl } from 'react-intl'
import Select from './Select'
import Checkbox from './Checkbox'

type SortDirectionIconProps = {
	asc?: boolean
}

export type SortByFieldProps = {
	menuItems: {
		value: string
		label: string
	}[]
	initialValues?: {
		sortBy: string
		sortDirection: 'asc' | 'desc'
	}
	onSort?: (column: string, direction: 'asc' | 'desc') => void
}

const SortDirectionIcon = ({
	asc = true,
}: SortDirectionIconProps) => {
	return (
		<span className="flex">
			<span className={`${asc ? '' : 'rotate-180'}`}>
				<Straight />
			</span>
			<Sort />
		</span>
	)
}

const SortByField = ({
	menuItems,
	initialValues = { sortBy: '', sortDirection: 'asc' },
	onSort,
}: SortByFieldProps) => {
	const { formatMessage } = useIntl()
	const [sortBy, setSortBy] = React.useState(initialValues.sortBy)
	const [sortDirection, setSortDirection] = React.useState(
		initialValues.sortDirection
	)

	const handleSortByChange = (event: SelectChangeEvent<unknown>) => {
		const newSortBy = event.target.value as string
		setSortBy(newSortBy)
		onSort?.(newSortBy, sortDirection)
	}

	const handleSortDirectionChange = () => {
		const newDirection = sortDirection === 'asc' ? 'desc' : 'asc'
		setSortDirection(newDirection)
		onSort?.(sortBy, newDirection)
	}
	return (
		<div className="flex gap-4 w-full sm:max-w-60">
			<Select<SortByFieldProps['menuItems'][0]>
				name="sortBy"
				label={formatMessage({ id: 'global.sort_by' })}
				menuItems={menuItems}
				selectProps={{
					value: sortBy,
					onChange: handleSortByChange,
				}}
				fullWidth
			/>
			<Checkbox
				icon={<SortDirectionIcon />}
				checkedIcon={<SortDirectionIcon asc={false} />}
				checked={sortDirection === 'desc'}
				onChange={handleSortDirectionChange}
			/>
		</div>
	)
}

export default SortByField
